import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-task-done",
  "use": "icon-task-done-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-task-done\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 15c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15Zm21.634-5.19-8.399 8.399-4.149-4.149L7.5 15.646l3.853 3.857a2.667 2.667 0 0 0 3.772 0l8.103-8.1-1.594-1.593Z\" fill=\"#07C160\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol